import React, { useEffect, useMemo, useState } from "react";
import { Alert, Typography, Spin } from "antd";
import SubscriptionIncludedApps from "../components/SubscriptionIncludedApps";
import "./SubscriptionPlans.css";
import { getPublicPlans } from "../api_v2/subscription";

const { Title } = Typography;

const planPresentation = {
  1: { theme: "basic", accent: "Гибкий старт" },
  3: { theme: "blue", accent: "Оптимально" },
  6: { theme: "highlight", badge: "Лучший выбор", accent: "Популярно" },
  12: { theme: "success", badge: "Максимум выгоды", accent: "На год" },
};

const formatMonths = months => {
  if (months === 1) return "1 месяц";
  if (months >= 2 && months <= 4) return `${months} месяца`;
  return `${months} месяцев`;
};

function SubscriptionPlans({ onCreatePayment, loading }) {
  const [plans, setPlans] = useState([]);
  const [plansLoading, setPlansLoading] = useState(true);
  const [plansError, setPlansError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const loadPlans = async () => {
      try {
        const data = await getPublicPlans();
        if (!cancelled && data?.success && Array.isArray(data.plans) && data.plans.length) {
          const apiPlans = data.plans.map((plan) => {
            const presentation = planPresentation[Number(plan.months)] || {
              theme: "basic",
              accent: "Тариф",
            };
            return {
              ...presentation,
              id: plan.id,
              months: Number(plan.months),
              price: Number(plan.amount),
            };
          });
          setPlans(apiPlans);
        } else if (!cancelled) {
          setPlansError("Тарифы временно недоступны. Попробуйте обновить страницу позже.");
        }
      } catch (error) {
        console.error("Ошибка загрузки тарифов:", error);
        if (!cancelled) {
          setPlansError("Не удалось загрузить актуальные тарифы. Оплата не начата.");
        }
      } finally {
        if (!cancelled) setPlansLoading(false);
      }
    };

    loadPlans();

    return () => {
      cancelled = true;
    };
  }, []);

  const baseMonthlyPrice = useMemo(
    () => plans.find(plan => plan.months === 1)?.price || plans[0]?.price || 0,
    [plans]
  );

  return (
    <div className="subscription-plans-container">
      <Title level={3} className="subscription-plans-title">
        Тарифы SIMOL VIP
      </Title>

      <SubscriptionIncludedApps className="subscription-apps-strip--plans" />

      {plansLoading && <Spin style={{ display: "block", marginBottom: 16 }} />}
      {plansError && <Alert type="warning" showIcon message={plansError} style={{ marginBottom: 16 }} />}

      <div className="plans-list">
        {plans.map((plan, i) => {
          const savings = Math.max(
            0,
            baseMonthlyPrice * plan.months - plan.price
          );
          return (
            <button
              key={plan.id || i}
              className={`plan-card plan-card--${plan.theme}`}
              onClick={() =>
                onCreatePayment(plan)
              }
              disabled={loading}
            >
              <div className="plan-card__glow" />
              <div className="plan-card__info">
                <span className="plan-card__accent">{plan.accent}</span>
                <div className="plan-card__title-row">
                  <h3 className="plan-card__title">
                    {formatMonths(plan.months)}
                  </h3>
                  {plan.badge && (
                    <span className="plan-card__badge">{plan.badge}</span>
                  )}
                </div>
                {savings > 0 && (
                  <p className="plan-card__savings">
                    Экономия {savings} ₽
                  </p>
                )}
              </div>
              <div className="plan-card__bottom">
                <div className="plan-card__price">{plan.price} ₽</div>
                <div className="plan-card__cta">Выбрать</div>
              </div>
            </button>
          );
        })}
      </div>

    </div>
  );
}

export default SubscriptionPlans;
